import React from 'react';

import classes from './FilterButtonLarge.scss';

const filterButtonLarge = (props) => {
    return (
        <button onClick={props.clicked} className={`${[classes.Box, props.isActive ? classes.BoxActive : null].join(' ')} u-flex justify-content-center align-items-center f-column u-fontSize11 u-fontWeightRegular u-cursorPointer u-border0`}>
            <img src={props.image} alt="Late Night" />
            <span style={{marginTop: '8px'}}>{props.children}</span>
        </button>
    );
}

export default filterButtonLarge;


// WEBPACK FOOTER //
// ./src/components/Filters/FilterButtonLarge/FilterButtonLarge.js